module.exports = __webpack_public_path__ + "static/media/ledger.49516592.svg";